// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"tQ-z","inlineTitle":"uQ-z","sponsoredAdsWrapper":"vQ-z","marketplaceRecosWrapper":"wQ-z"};